module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-authentication/client.js
// module id = 238
// module chunks = 0